import React from 'react';
import { useState } from 'react';
import { storeFile } from '@/_utils/utils';
import { Divider, Grid, IconButton, Tooltip } from '@mui/material';
import baseAxios from 'axios';
import LabelValue from '../../LabelValue';
import PolarisIcon from '../../PolarisIcon';
import { useToast } from '../../Toast';
import axios from '../../../../_utils/axios';

const InventoryLink = ({ fileName, label, url, formContext }) => {
  const [downloading, setDownloading] = useState(false);
  const { error } = useToast();

  const downloadFile = (response, filename) => {
    storeFile(response, filename);
    setDownloading(false);
  };

  const handleAWSDownload = () => {
    baseAxios({ url, method: 'GET', responseType: 'blob' })
      .then((res) =>
        downloadFile(res, fileName).catch((err) => {
          error(err.response?.data?.message || 'There was a problem downloading the file.');
        })
      )
      .catch((err) => error(err.response?.data?.message || 'There was a problem downloading the file.'))
      .then(() => setDownloading(false));
  };

  const handleCoreDownload = () => {
    axios
      .get(url.replace('/api/v1', ''))
      .then((res) => {
        if (!res?.data?.data?.uri) throw new Error();
        else {
          const filetype = res?.data?.data?.file_type && res.data.data.file_type.replace('.', '');
          const url = res?.data?.data?.uri;
          // we use axios without defaults because AWS complains if we set Authorization header on the s3 request
          if (url) {
            baseAxios({ url, method: 'GET', responseType: 'blob' }).then((res) => {
              const jobID = formContext?.task?.job?.id;
              const formattedFilename = `${fileName}${!!jobID && `_J${jobID}.${filetype}`}`;
              downloadFile(res, formattedFilename);
            });
          }
        }
      })
      .finally(() => setDownloading(false));
  };

  const handleDownload = () => {
    setDownloading(true);
    const isCoreUrl = url.includes('/api/v1');
    isCoreUrl ? handleCoreDownload() : handleAWSDownload();
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center" columnSpacing={2} wrap="nowrap">
      <LabelValue label={label} />
      <Grid item xs="auto" style={{ flex: 'auto' }}>
        <Divider sx={{ borderStyle: 'dotted' }} />
      </Grid>

      <Grid item xs="auto">
        {url?.length ? (
          <Tooltip title="Download File" placement="top">
            <IconButton onClick={handleDownload} aria-label="download" color="primary" size="large" edge="end">
              <PolarisIcon icon={downloading ? 'loading' : 'download'} />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="File Not Available" placement="top">
            <PolarisIcon icon="file_none" style={{ opacity: 0.5 }} height={22} />
          </Tooltip>
        )}
      </Grid>
    </Grid>
  );
};

export default InventoryLink;
